import React from "react";
import "./Dashboard.css";

import VisitorsSection from "./VisitorsSection/VisitorsSection";
import UserProgressSection from "./UserProgressSection/UserProgressSection";
import SignupsSection from "./SignupsSection/SignupsSection";
import OrdersAndRevenueSection from "./OrdersAndRevenueSection/OrdersAndRevenueSection";
import SmsSection from "./SmsSection/SmsSection";
import PushNotificationsSection from "./PushNotificationsSection/PushNotificationsSection";

function Dashboard() {
  return (
    <div className="dashboard-container">
      <VisitorsSection />
      <OrdersAndRevenueSection />
      <UserProgressSection />
      <SignupsSection />
      <SmsSection />
      <PushNotificationsSection />
    </div>
  );
}

export default Dashboard;
